/*
 * @Autor: lianxiben
 * @Date: 2023-02-17 15:37:24
 * @LastEditors: lianxiben
 * @LastEditTime: 2023-02-17 15:38:28
 */
import Index from '../../pages/tideng/anniversaryCelebration/index';
import Appointment from '../../pages/tideng/anniversaryCelebration/appointment';

const base = 'anniversaryCelebration';

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/appointment*`,
    name: `${base}-appointment`,
    component: Appointment
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/tideng/anniversaryCelebration.js